<template>
  <div class="main">

    <div id="score" v-show="currentQindex < totalQuestions">
      question {{currentQindex+1}} / {{totalQuestions}} &nbsp; &nbsp; score {{ currentScore }} / {{totalQuestions*2}}
    </div>
    
    <div v-for="(q, index) in randomQuestions">

      <div v-show="index === currentQindex">

        <div class="debug" v-show="debug === true">
          (DEBUGGING - ANSWERS SHOWN)<br>
          volume: {{ q.volume }}<br>
          uncertainty: {{ q.uncertainty }}<br>
          cylinder total: {{ q.total }}<br>
        </div>

        <div class="question">

          <div class="cylinder" v-bind:class="{ looking: isLooking[index] }">
            <button class="btn alt" v-on:click="lookOn(index)">Get a closer look</button>
            <img :src="'static/' + q.cylinder" v-bind:alt="q.name" width="126" height="511">
            <div class="closer-look">
              <img :src="'static/' + q.zoom" v-bind:alt="q.name + ' zoom'" width="316" height="316">
              <span v-on:click="lookOff(index)">&times;</span>
            </div>
          </div>
        
          <div class="guesses" v-show="halfStep === false && finalStep === false" v-bind:class="{ neutral: !firstWrong, wrong: firstWrong }">

            <p class="neutral">Select the most accurate volume.</p>
            <p class="wrong">Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.</p>

            <div v-for="(o, i) in q.options" :class="'guess-option_'+index" class="guess-option">
              <span>
                <input :name="index+'_guess-option'" :id="index+'_'+i" type="radio" :value="o" :disabled="firstWrong === true" v-model="guessVolume[index]" v-on:change="checkVolumeGuess" autocomplete="off">
                <label :for="index+'_'+i">{{ o }} mL</label>
              </span>
            </div>
            <button class="guess btn neutral" v-on:click="submitAnswer">Submit Answer</button>
            <button class="guess btn wrong" v-on:click="continueWrong">Continue</button>
          </div>

          <div class="guesses" v-show="halfStep === true && finalStep === false">
            <p>
              <span v-show="firstWrong === false">Correct! Now, determine the uncertainty value for the measurement.</span>
              <span v-show="firstWrong === true">Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.</span>
            </p>
            <div class="uncertainty-guess">
              <span>{{ q.volume }}</span>
              <span class="porm">&plusmn;</span>
              <span class="input">
                <input v-model="guessUncertainty[index]" type="number" min="0" step="0.01" name="guessUncertainty[]" autocomplete="off" value="0.00"><span>mL</span>
              </span>
            </div>
            <button class="guess btn" v-on:click="submitUncertainty">Submit Uncertainty</button>
          </div>

          <div class="guesses" v-show="finalStep === true">
            <p>
              <span v-show="secondWrong === false">Correct!</span>
              <span v-show="secondWrong === true">Incorrect! The uncertainty value is half of the distance between the markings indicated on the graduated cylinder</span>
            </p>
            <div v-show="secondWrong === false">
              <div class="big">{{ q.volume }}mL &plusmn; {{ q.uncertainty }}mL</div>
            </div>
            <div v-show="secondWrong === true">
              <div class="uncertainty-guess">
                <span>{{ q.volume }}</span>
                <span class="porm">&plusmn;</span>
                <span class="input wrong">
                  <input disabled v-model="guessUncertainty[index]" type="number" name="guessUncertainty[]" autocomplete="off"><span>mL</span>
                </span>
              </div>
            </div>
            <div v-show="currentQindex+1 === totalQuestions">
              <button class="guess btn final" v-on:click="nextQuestion">Continue <span>&rarr;</span></button>
            </div>
            <div v-show="currentQindex+1 < totalQuestions">
              <button class="guess btn final" v-on:click="nextQuestion">Next Question <span>&rarr;</span></button>
            </div>
          </div>

        </div>

      </div>

    </div>

    <div v-show="currentQindex === totalQuestions" class="outro">
      <div class="bg"></div>
      <div class="outro-inner">
        <h1>You completed the quiz!</h1>
        <p>Your final score was <span>{{ currentScore }}</span> / {{totalQuestions*2}}. If you scored...</p>
        <ul>
          <li :class="currentScore < 13 ? 'scored' : ''">0–12 points: having a bad day? Ask your teacher for help.</li>
          <li :class="currentScore >= 13 && currentScore <= 16 ? 'scored' : ''">13–16 points: not bad! If you need more practice, try taking the quiz again.</li>
          <li :class="currentScore > 16 ? 'scored' : ''">17–20 points: great job! You have great measurement skills.</li>
        </ul>
        <button class="btn" id="reset" v-on:click="resetEverything">Start over</button>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'quiz',
  data: function () {
    return {
      debug: false,
      totalQuestions: 10,
      guessVolume: [],
      guessUncertainty: [],
      currentQindex: 0,
      currentScore: 0,
      randomQuestions: [],
      halfStep: false,
      firstWrong: false,
      secondWrong: false,
      finalStep: false,
      isLooking: []
    }
  },
  props: [
    'questions',
    'startedQuiz'
  ],
  methods: {
    lookOn: function (index) {
      // there has to be a better way to do this... but this works ¯\_(ツ)_/¯
      var a = JSON.parse(JSON.stringify(this.isLooking)); a[index] = true // what?
      this.$set(this, 'isLooking', a) // use Vue.set so the dom responds
    },
    lookOff: function (index) {
      var a = JSON.parse(JSON.stringify(this.isLooking)); a[index] = false // ok!
      this.$set(this, 'isLooking', a)
    },
    submitAnswer: function () {
      var Qi = this.currentQindex
      var answerVolume = this.randomQuestions[Qi].volume
      var guessVolume = this.guessVolume[Qi]

      if (!guessVolume) { alert('Please select a volume'); return }

      if (guessVolume === answerVolume) {
        this.currentScore++
        this.$set(this, 'halfStep', true)
      } else {
        this.$set(this, 'firstWrong', true)
      }
    },
    continueWrong: function () {
      this.$set(this, 'halfStep', true)
    },
    submitUncertainty: function () {
      var Qi = this.currentQindex
      var answerUncertainty = parseFloat(this.randomQuestions[Qi].uncertainty)
      var guessUncertainty = parseFloat(this.guessUncertainty[Qi])

      if (!guessUncertainty) { alert('Please specify a numerical uncertainty value'); return }

      if (guessUncertainty === answerUncertainty) {
        this.currentScore++
      } else {
        this.$set(this, 'secondWrong', true)
      }
      this.$set(this, 'finalStep', true)
    },
    nextQuestion: function () {
      this.halfStep = false
      this.finalStep = false
      this.firstWrong = false
      this.secondWrong = false
      this.currentQindex++
    },
    checkVolumeGuess: function (e) {
      if (this.firstWrong === true) { return false } // already guessed, get out!

      var Qi = this.currentQindex
      var guessVolume = this.guessVolume[Qi]
      var answerVolume = this.randomQuestions[Qi].volume

      var opts = document.querySelectorAll('.guess-option_' + Qi + ' input')
      var i
      for (i = 0; i < opts.length; i++) {
        opts[i].classList.remove('incorrect', 'correct')
        if (opts[i].value === answerVolume) { opts[i].classList.add('correct') }
      }

      if (answerVolume !== guessVolume) {
        e.target.classList.add('incorrect')
      }
    },
    resetEverything: function () {
      this.currentQindex = 0
      this.currentScore = 0
      this.guessVolume = []
      this.guessUncertainty = []
      this.halfStep = false
      this.finalStep = false
      this.firstWrong = false
      this.secondWrong = false
      this.$emit('restartQuiz') // tell the parent component we're restarting too
      this.randomizeQuestions()
    },
    randomizeQuestions: function () {
      var array = this.questions
      var currentIndex = array.length
      var temporaryValue, randomIndex
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      this.randomQuestions = array.slice(0, this.totalQuestions)
      this.halfStep = false
    }
  },
  created: function () {
    this.randomizeQuestions()
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles.scss";

#score { 
  text-align:right;
  font-size: 20px;
  color: $grey;
  margin: 10px 0;
  font-variant: small-caps;
  height: 25px;
}

.question {
  display: flex;
  width: 100%;
  margin: 10px auto;
  align-items:center;
  justify-content: center;  

  .btn { width: 100%; }

}

.btn.alt {
  border: solid 1px $blue;
  background: #fff url(../../static/eye.svg) no-repeat 20% 50% / 30px auto;
  color: $blue;
  padding: 10px 0 10px 30px;
  margin-bottom: 30px;
}

.guesses {
  width: 50%;
  p { 
    margin: 0;
    height: 90px;
    text-align: left;
  }
  .guess-option {
    width: 32%;
    display: inline-block;
  }
  .guess-option:nth-of-type(2) {
    margin: 0 2%;
  }
  input[type='radio'] {
    display: none;
  }
  label {
    display: block;
    width: 100%;
    padding: 10px;
    border: solid 1px $grey;
    color: #fff;
    letter-spacing: 1px;
    cursor: pointer;
    color: $dk_grey;
  }
  input[type='radio']:checked ~ label {
    background: lighten($grey,15%);
  }
  &.wrong input.correct ~ label {
    border: solid 2px $blue;
    margin: -1px;
  }
  &.wrong input.incorrect:checked ~ label {
    border: solid 1px $red;
    background: $lt_grey;
  }

  &.wrong .neutral { display: none; }
  &.neutral .wrong { display: none; }

}

.guess.btn { margin-top: 30px; }
.final.btn {
  color: $blue;
  background: #fff;
  span { font-size: 20px; line-height: 16px; }
}

.big { font-size: 32px; color: $dk_grey; }

.uncertainty-guess {
  text-align: left;
  font-size: 30px;
  color: $dk_grey;
  .porm { 
    display: inline-block; 
    padding: 0 8px; 
  }
  .input {
    display: inline-block; 
    border: solid 2px $grey;
    height: 50px;
    span {
      display: inline-block; 
      padding: 0 10px; 
      background: $lt_grey;
      font-size: 24px;
      line-height: 50px;
      height: 46px;
      border-left: solid 2px $grey;
    }
    input { 
      vertical-align: top;
      display: inline-block;
      border: none;
      color: $dk_grey;
      padding: 0 0 0 10px;
      margin: 0;
      font: normal 24px/46px $font-family;
      height: 46px;
      width: 200px;
    }
    &.wrong {
      border: solid 2px $red;
      background: $lt_grey;
      span { border-left: solid 2px $red; }
      input { background: $lt_grey; }
    }
  }
}

.cylinder { 
  width: 50%;
  text-align: center;
  position: relative;
  &> .btn, &> img { transition: all 0.35s ease-in; }
}
.closer-look {
  display: block;
  position: absolute;
  top:20%;
  left:10%;
  border-radius: 50%;
  background: #fff;
  transform: scale3d(0.35,0.35,1) rotate(5deg);
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.2, 1.4, 0.8, 1.2);
  img { 
    display: block; 
    border: solid 3px $grey;
    border-radius: 50%;
    overflow: hidden;
  }
  span {
    position: absolute;
    top: 15%;
    left: 5%;
    border: solid 2px $grey;
    border-radius: 50%;
    background: #fff;
    color: $grey;
    font-size: 32px;
    line-height: 32px;
    display: block;
    width: 32px;
    height: 32px;
    text-align: center;
    cursor: pointer;
  }
}
.looking {
  .closer-look { 
    transform: scale3d(1,1,1);
    opacity: 1;
  }
  &> .btn, &> img { opacity: 0.2; }
}
.outro {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  h1, p {
    font: bold 32px $font-family;
    color: $dk_grey;
    margin: 0 0 16px;
    letter-spacing: 1.5px;
  }
  ul {
    text-align: left;
    list-style: none;
    font: bold 20px $font-family;
    padding: 0;
    margin: 0 0 40px;
    color: $grey;
    li.scored { color: $blue; }
  }
  p span { color: $blue; }
  .outro-inner { position: relative; }
  .bg {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff url(../../static/cylinder.svg) no-repeat center center;
    opacity: 0.1;
  }
}

.debug { background: $lt_grey; padding: 10px; position: fixed; bottom: 0; right: 0; width: auto; z-index: 9; }
</style>



// WEBPACK FOOTER //
// Quiz.vue?19ae2202